/**
 * @param {Color[]} colors
 * @param {Sprites} sprites
 * @param {Object} options
 * @param {function(Color, boolean): string} [options.calcLabel]
 * @param {function(Color): boolean} [options.isColorAvailable]
 * @returns {ColorOption[]}
 */
export const prepareSprites = (
  colors,
  sprites,
  {
    isColorAvailable = () => true,
    calcLabel = (color, isAvailable) => `Color: ${isAvailable ? color.name : `${color.name} is unavailable`}`,
  },
) => (colors).map((color) => {
  const isAvailable = isColorAvailable(color);
  const label = calcLabel(color, isAvailable);

  return {
    id: color.id,
    isAvailable,
    label,
    sprite: {
      index: color.swatchImage.swatchSpriteUrlIndex,
      src: sprites.urlTemplate + sprites.swatchSpriteUrls[color.swatchImage.swatchSpriteUrlIndex],
      offset: color.swatchImage.swatchSpriteOffset,
    },
  };
});

/**
 * @param {PriceToColorItem[]} priceToColors
 * @param {BaseColor[]} colors
 * @returns {ColorPane[]}
 */
export const prepareColorPanes = (priceToColors, colors, colorwayExp) => priceToColors
  .map(({ price, onSale, colorIds }, index) => ({
    index,
    price: {
      value: price,
      onSale,
    },
    colors: colorwayExp ? colorIds.map((id) => colors.find((color) => color.id === id)).filter(Boolean)
      : colors.filter((color) => colorIds.includes(color.id)),
  }));

export default {
  prepareSprites,
  prepareColorPanes,
};
